import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useToastMutation } from '../utils/mutation';
import type { Custodian } from '../../types/collection';

export function useCustodians(projectId: string) {
  return useQuery<Custodian[]>({
    queryKey: ['custodians', projectId],
    queryFn: () => api.get<Custodian[]>(`/project/${projectId}/custodian`),
    enabled: !!projectId,
  });
}

export function useCreateCustodian(projectId: string) {
  // Invalidates useProject since custodians are embedded in the project response.
  return useToastMutation(
    ['project', projectId],
    (name: string) => api.post(`/project/${projectId}/custodian`, { projectId, name }),
    {
      success: (_d, name) => ({ title: 'Custodian added successfully', description: `Name: ${name}`, timeout: 5000 }),
    }
  );
}
